import { styled } from "@mui/material/styles";

export const CostEstimationText = styled("div", {
  label: "cost-estimation-text",
})`
  display: flex;
  flex-direction: column;
  max-width: 50%;
  font-weight: 400;
  line-height: 1.5;

  ${({ theme }) => theme.breakpoints.up("md")} {
    margin: ${({ theme }) => theme.spacing(4, 0)};
  }
`;

export const EstimatedCost = styled("div", {
  label: "estimated-cost",
})`
  display: flex;
  flex-direction: row;
  max-width: 50%;
  font-weight: 400;
  line-height: 1.5;
  align-items: center;

  ${({ theme }) => theme.breakpoints.up("md")} {
    margin: ${({ theme }) => theme.spacing(4, 0)};
  }
`;

export const CostDisclaimerText = styled("p", {
  label: "cost-disclaimer-text",
})`
  color: ${({ theme }) => theme.palette.color.text.primary};
  font-size: 14px;
`;

export const CostDisclaimerTitle = styled("h3", {
  label: "cost-disclaimer-title",
})`
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: 16px;
`;

export const Container = styled("div", {
  label: "trip-cost-estimation",
})`
  display: flex;
  align-items: flex-start;
  position: relative;
  justify-content: space-between;
  border-top: 1px solid ${({ theme }) => theme.palette.color.gray[85]};
  border-bottom: 1px solid ${({ theme }) => theme.palette.color.gray[85]};
  margin: ${({ theme }) => theme.spacing(0, 4)};

  &:before {
    content: "";
    position: absolute;
    left: ${({ theme }) => theme.spacing(2)};
    right: ${({ theme }) => theme.spacing(2)};
    height: theme.spacing(0.125);
    background-color: ${({ theme }) => theme.palette.color.gray[85]};
  }

  &:before {
    top: 0;
  }

  &:after {
    bottom: 0;
  }
`;

export const ErrorMessage = styled("div", {
  label: "error-message",
})`
  color: ${({ theme }) => theme.palette.color.alert.main};
  font-size: 14px;
  left: 0;
  line-height: 1.29;
  margin-top: ${({ theme }) => theme.spacing(1)};
  width: 100%;
  flex: 1;
  white-space: nowrap;
  ${({ theme }) => theme.breakpoints.down("md")} {
    text-align: center;
  }
`;
